import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=3d214dbc&scoped=true"
import script from "./xieyi.vue?vue&type=script&lang=js"
export * from "./xieyi.vue?vue&type=script&lang=js"
import style0 from "./xieyi.vue?vue&type=style&index=0&id=3d214dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d214dbc",
  null
  
)

export default component.exports